import React, { useState, useEffect } from 'react';
import { authService, categorieService } from '../../api';
import './Inscription.css';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { FaGraduationCap, FaUserTie, FaUserGraduate, FaBuilding, FaArrowLeft, FaEyeSlash, FaEye, FaCamera, FaTimes } from 'react-icons/fa';

const Inscription = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    prenom: '',
    email: '',
    password: '',
    password_confirmation: '',
    role: '',
    ville: '',
    bio: '',
    telephone: '',
    linkedin: '',
    services: '',
    besoins: '',
    tarif: '',
    prix: '',
    modes_accompagnement: '',
    region_couverte: '',
    nom_entreprise: '',
    siret: '',
    site_internet: '',
    secteur_activite: '',
    niveau_etude: '',
    pays_origine: '',
    specialite_etudes: '',
    secteur_pro: '',
    annee_arrivee_fr: '',
  });

  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageError, setImageError] = useState('');
  const [errors, setErrors] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [submitError, setSubmitError] = useState('');
  const [regionSuggestions, setRegionSuggestions] = useState([]);
  const [showRegionSuggestions, setShowRegionSuggestions] = useState(false);
  const [villeSuggestions, setVilleSuggestions] = useState([]);
  const [showVilleSuggestions, setShowVilleSuggestions] = useState(false);
  const [paysSuggestions, setPaysSuggestions] = useState([]);
  const [showPaysSuggestions, setShowPaysSuggestions] = useState(false);
  const [specialiteSuggestions, setSpecialiteSuggestions] = useState([]);
  const [showSpecialiteSuggestions, setShowSpecialiteSuggestions] = useState(false);
  const [secteurProSuggestions, setSecteurProSuggestions] = useState([]);
  const [showSecteurProSuggestions, setShowSecteurProSuggestions] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedBesoins, setSelectedBesoins] = useState([]);
  const [selectedModes, setSelectedModes] = useState([]);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const customServices = [
    {
      nom: 'Accompagnement juridique',
      sous_services: [
        { id: 'juridique_1', nom: 'Rupture de contrat' },
        { id: 'juridique_2', nom: 'Titre de séjour' },
        { id: 'juridique_3', nom: 'OQTF' },
        { id: 'juridique_4', nom: 'Autres' }
      ]
    },
    {
      nom: 'Aide financière',
      sous_services: [
        { id: 'financiere_1', nom: 'Assistance sociale' },
        { id: 'financiere_2', nom: 'Dons matériels' },
        { id: 'financiere_3', nom: 'Dons financiers' }
      ]
    },
    {
      nom: 'Projet d\'étude',
      sous_services: [
        { id: 'etude_1', nom: 'Obtenir une admission' },
        { id: 'etude_2', nom: 'Rechercher des formations' },
        { id: 'etude_3', nom: 'Orientation' }
      ]
    },
    {
      nom: 'Evènements PRO',
      sous_services: [
        { id: 'event_1', nom: 'Évènements' },
        { id: 'event_2', nom: 'Webinaires' }
      ]
    },
    {
      nom: 'Bien-être et intégration',
      sous_services: [
        { id: 'bienetre_1', nom: 'Santé mentale' },
        { id: 'bienetre_2', nom: 'Intégration' },
        { id: 'bienetre_3', nom: 'Loisir' },
        { id: 'bienetre_4', nom: 'Rencontre' }
      ]
    },
    {
      nom: 'Tourisme',
      sous_services: [
        { id: 'tourisme_1', nom: 'Bons plans' },
        { id: 'tourisme_2', nom: 'Activités' },
        { id: 'tourisme_3', nom: 'Voyage' },
        { id: 'tourisme_4', nom: 'Événements cultuels' }
      ]
    },
    {
      nom: 'Situation administrative',
      sous_services: [
        { id: 'admin_1', nom: 'Renouvellement titre de séjour' },
        { id: 'admin_2', nom: 'Changement de statut' },
        { id: 'admin_3', nom: 'Démarches administratives' }
      ]
    },
    {
      nom: 'Logement',
      sous_services: [
        { id: 'logement_1', nom: 'Colocation' },
        { id: 'logement_2', nom: 'Appartement' },
        { id: 'logement_3', nom: 'Hébergement provisoire' }
      ]
    },
    {
      nom: 'Emploi',
      sous_services: [
        { id: 'emploi_1', nom: 'Job étudiant' },
        { id: 'emploi_2', nom: 'CDI / CDD' },
        { id: 'emploi_3', nom: 'Alternance / Stage' }
      ]
    }
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 1949 }, (_, i) => currentYear - i);

  const niveauxEtude = [
    'Bac+1',
    'Bac+2', 
    'Bac+3',
    'Bac+4',
    'Bac+5',
    'Bac+6',
    'Bac+7',
    'Bac+8'
  ];

  const specialitesEtudes = [
    'Informatique',
    'Commerce',
    'Marketing',
    'Finance',
    'Droit',
    'Médecine',
    'Ingénierie',
    'Architecture',
    'Design',
    'Communication',
    'Ressources Humaines',
    'Tourisme',
    'Hôtellerie',
    'Arts',
    'Sciences Politiques'
  ];

  const secteursPro = [
    'Technologie',
    'Santé',
    'Éducation',
    'Finance',
    'Commerce',
    'Industrie',
    'Transport',
    'Construction',
    'Agriculture',
    'Energie',
    'Environnement',
    'Culture',
    'Sport',
    'Assurance',
    'Immobilier'
  ];

  const frenchRegions = [
    "Auvergne-Rhône-Alpes",
    "Bourgogne-Franche-Comté",
    "Bretagne",
    "Centre-Val de Loire",
    "Corse",
    "Grand Est",
    "Hauts-de-France",
    "Île-de-France",
    "Normandie",
    "Nouvelle-Aquitaine",
    "Occitanie",
    "Pays de la Loire",
    "Provence-Alpes-Côte d'Azur",
    "Guadeloupe",
    "Martinique",
    "Guyane",
    "La Réunion",
    "Mayotte"
  ];

  // Fonction pour gérer l'upload d'image
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validation du type de fichier
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      setImageError('Format de fichier non supporté. Utilisez JPG, PNG ou GIF.');
      return;
    }

    // Validation de la taille (2MB maximum)
    const maxSize = 2 * 1024 * 1024; // 2MB
    if (file.size > maxSize) {
      setImageError('L\'image ne doit pas dépasser 2MB.');
      return;
    }

    setImageError('');
    setImage(file);

    // Créer une preview
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  // Fonction pour supprimer l'image
  const removeImage = () => {
    setImage(null);
    setImagePreview(null);
    setImageError('');
  };

  // Validation en temps réel
  const validateField = (name, value) => {
    const newErrors = { ...fieldErrors };
    
    switch (name) {
      case 'name':
        if (!value.trim()) {
          newErrors[name] = 'Le nom est requis';
        } else if (value.length < 2) {
          newErrors[name] = 'Le nom doit contenir au moins 2 caractères';
        } else if (value.length > 50) {
          newErrors[name] = 'Le nom ne peut pas dépasser 50 caractères';
        } else if (!/^[a-zA-ZÀ-ÿ\s\-']+$/.test(value)) {
          newErrors[name] = 'Le nom ne peut contenir que des lettres';
        } else {
          delete newErrors[name];
        }
        break;
        
      case 'prenom':
        if (!value.trim()) {
          newErrors[name] = 'Le prénom est requis';
        } else if (value.length < 2) {
          newErrors[name] = 'Le prénom doit contenir au moins 2 caractères';
        } else if (value.length > 50) {
          newErrors[name] = 'Le prénom ne peut pas dépasser 50 caractères';
        } else if (!/^[a-zA-ZÀ-ÿ\s\-']+$/.test(value)) {
          newErrors[name] = 'Le prénom ne peut contenir que des lettres';
        } else {
          delete newErrors[name];
        }
        break;
        
      case 'email':
        if (!value.trim()) {
          newErrors[name] = 'L\'email est requis';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          newErrors[name] = 'Format d\'email invalide';
        } else {
          delete newErrors[name];
        }
        break;
        
      case 'password':
        if (!value) {
          newErrors[name] = 'Le mot de passe est requis';
        } else if (value.length < 8) {
          newErrors[name] = 'Le mot de passe doit contenir au moins 8 caractères';
        } else if (!/(?=.*[A-Z])/.test(value)) {
          newErrors[name] = 'Le mot de passe doit contenir au moins une majuscule';
        } else if (!/(?=.*[0-9])/.test(value)) {
          newErrors[name] = 'Le mot de passe doit contenir au moins un chiffre';
        } else if (!/(?=.*[!@#$%^&*])/.test(value)) {
          newErrors[name] = 'Le mot de passe doit contenir au moins un caractère spécial';
        } else {
          delete newErrors[name];
        }
        break;
        
      case 'password_confirmation':
        if (!value) {
          newErrors[name] = 'La confirmation du mot de passe est requise';
        } else if (value !== formData.password) {
          newErrors[name] = 'Les mots de passe ne correspondent pas';
        } else {
          delete newErrors[name];
        }
        break;
        
      case 'telephone':
        if (value && !/^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/.test(value)) {
          newErrors[name] = 'Format de téléphone invalide';
        } else if (value && !/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/.test(value.replace(/\s/g, ''))) {
          newErrors[name] = 'Numéro de téléphone français invalide';
        } else {
          delete newErrors[name];
        }
        break;
        
      case 'linkedin':
        if (value && !/^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9\-_]+\/?$/.test(value)) {
          newErrors[name] = 'Lien LinkedIn invalide';
        } else {
          delete newErrors[name];
        }
        break;
        
      case 'site_internet':
        if (value && !/^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?\/?$/.test(value)) {
          newErrors[name] = 'URL de site web invalide';
        } else {
          delete newErrors[name];
        }
        break;
        
      case 'siret':
        if (value && !/^\d{14}$/.test(value.replace(/\s/g, ''))) {
          newErrors[name] = 'Le SIRET doit contenir 14 chiffres';
        } else {
          delete newErrors[name];
        }
        break;
        
      case 'prix':
        if (formData.tarif === 'payant' && !value) {
          newErrors[name] = 'Le prix est requis pour un service payant';
        } else if (value && !/^\d+(\.\d{1,2})?$/.test(value)) {
          newErrors[name] = 'Format de prix invalide (ex: 50 ou 49.99)';
        } else if (value && parseFloat(value) <= 0) {
          newErrors[name] = 'Le prix doit être supérieur à 0';
        } else {
          delete newErrors[name];
        }
        break;
        
      case 'ville':
        if (value && value.length < 2 && value.length > 0) {
          newErrors[name] = 'La ville doit contenir au moins 2 caractères';
        } else {
          delete newErrors[name];
        }
        break;
        
      case 'bio':
        if (value && value.length > 500) {
          newErrors[name] = 'La bio ne peut pas dépasser 500 caractères';
        } else {
          delete newErrors[name];
        }
        break;
        
      case 'tarif':
        if (formData.role === 'expert' && !value) {
          newErrors[name] = 'Veuillez sélectionner un tarif';
        } else {
          delete newErrors[name];
        }
        break;

      case 'modes_accompagnement':
        if (formData.role === 'expert' && !value) {
          newErrors[name] = 'Veuillez sélectionner au moins un mode d\'accompagnement';
        } else {
          delete newErrors[name];
        }
        break;
    }
    
    setFieldErrors(newErrors);
  };

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const categoriesData = await categorieService.getAllCategories();
        setCategories(categoriesData);
      } catch (error) {
        console.error('Erreur lors du chargement des catégories:', error);
      }
    };
    loadCategories();
  }, []);

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched(prev => ({ ...prev, [name]: true }));
    validateField(name, value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // Validation en temps réel après modification
    if (touched[name]) {
      validateField(name, value);
    }
    
    // Recherches auto-complétion
    if (name === 'region_couverte') {
      searchRegions(value);
    }
    if (name === 'ville') {
      searchVilles(value);
    }
    if (name === 'pays_origine') {
      searchPays(value);
    }
    if (name === 'specialite_etudes') {
      searchSpecialites(value);
    }
    if (name === 'secteur_pro') {
      searchSecteursPro(value);
    }
  };

  const handleModeSelection = (mode) => {
    let updatedModes;
    if (selectedModes.includes(mode)) {
      updatedModes = selectedModes.filter(m => m !== mode);
    } else {
      updatedModes = [...selectedModes, mode];
    }
    setSelectedModes(updatedModes);
    
    const modesString = updatedModes.join(', ');
    setFormData(prev => ({ 
      ...prev, 
      modes_accompagnement: modesString 
    }));
    
    if (updatedModes.length === 0) {
      setFieldErrors(prev => ({ 
        ...prev, 
        modes_accompagnement: 'Veuillez sélectionner au moins un mode d\'accompagnement' 
      }));
    } else {
      const newErrors = { ...fieldErrors };
      delete newErrors.modes_accompagnement;
      setFieldErrors(newErrors);
    }
    
    setTouched(prev => ({ ...prev, modes_accompagnement: true }));
  };

  const searchRegions = (query) => {
    if (query.length < 2) {
      setRegionSuggestions([]);
      setShowRegionSuggestions(false);
      return;
    }
    const filteredRegions = frenchRegions.filter(region =>
      region.toLowerCase().includes(query.toLowerCase())
    );
    setRegionSuggestions(filteredRegions);
    setShowRegionSuggestions(true);
  };

  const searchVilles = async (query) => {
    if (query.length < 2) {
      setVilleSuggestions([]);
      setShowVilleSuggestions(false);
      return;
    }
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search?format=json&q=${query}&countrycodes=fr&limit=5`
      );
      const villes = response.data.map(item => item.display_name);
      setVilleSuggestions(villes);
      setShowVilleSuggestions(true);
    } catch (error) {
      console.error('Erreur recherche villes:', error);
    }
  };

  const searchPays = async (query) => {
    if (query.length < 2) {
      setPaysSuggestions([]);
      setShowPaysSuggestions(false);
      return;
    }
    try {
      const response = await axios.get(
        `https://restcountries.com/v3.1/name/${query}?fields=name`
      );
      const pays = response.data.map(country => country.name.common);
      setPaysSuggestions(pays);
      setShowPaysSuggestions(true);
    } catch (error) {
      console.error('Erreur recherche pays:', error);
    }
  };

  const searchSpecialites = (query) => {
    if (query.length < 2) {
      setSpecialiteSuggestions([]);
      setShowSpecialiteSuggestions(false);
      return;
    }
    const filteredSpecialites = specialitesEtudes.filter(specialite =>
      specialite.toLowerCase().includes(query.toLowerCase())
    );
    setSpecialiteSuggestions(filteredSpecialites);
    setShowSpecialiteSuggestions(true);
  };

  const searchSecteursPro = (query) => {
    if (query.length < 2) {
      setSecteurProSuggestions([]);
      setShowSecteurProSuggestions(false);
      return;
    }
    const filteredSecteurs = secteursPro.filter(secteur =>
      secteur.toLowerCase().includes(query.toLowerCase())
    );
    setSecteurProSuggestions(filteredSecteurs);
    setShowSecteurProSuggestions(true);
  };

  const selectRegion = (region) => {
    setFormData(prev => ({ ...prev, region_couverte: region }));
    setShowRegionSuggestions(false);
    validateField('region_couverte', region);
  };

  const selectVille = (ville) => {
    setFormData(prev => ({ ...prev, ville }));
    setShowVilleSuggestions(false);
    validateField('ville', ville);
  };

  const selectPays = (pays) => {
    setFormData(prev => ({ ...prev, pays_origine: pays }));
    setShowPaysSuggestions(false);
    validateField('pays_origine', pays);
  };

  const selectSpecialite = (specialite) => {
    setFormData(prev => ({ ...prev, specialite_etudes: specialite }));
    setShowSpecialiteSuggestions(false);
    validateField('specialite_etudes', specialite);
  };

  const selectSecteurPro = (secteur) => {
    setFormData(prev => ({ ...prev, secteur_pro: secteur }));
    setShowSecteurProSuggestions(false);
    validateField('secteur_pro', secteur);
  };

  const handleServiceSelection = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
    setSelectedServices(selectedOptions);
    setFormData(prev => ({ 
      ...prev, 
      services: selectedOptions.join(', ') 
    }));
    if (selectedOptions.length === 0) {
      setFieldErrors(prev => ({ ...prev, services: 'Veuillez sélectionner au moins un service' }));
    } else {
      const newErrors = { ...fieldErrors };
      delete newErrors.services;
      setFieldErrors(newErrors);
    }
  };

  const handleBesoinsSelection = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
    setSelectedBesoins(selectedOptions);
    setFormData(prev => ({ 
      ...prev, 
      besoins: selectedOptions.join(', ') 
    }));
    if (selectedOptions.length === 0) {
      setFieldErrors(prev => ({ ...prev, besoins: 'Veuillez sélectionner au moins un besoin' }));
    } else {
      const newErrors = { ...fieldErrors };
      delete newErrors.besoins;
      setFieldErrors(newErrors);
    }
  };

 const validateForm = () => {
  const newErrors = {};
  
  const requiredFields = ['email', 'password', 'password_confirmation'];
  
  if (formData.role !== 'entreprise') {
    requiredFields.push('name', 'prenom');
  }
  
  requiredFields.forEach(field => {
    if (!formData[field]) {
      newErrors[field] = `Le champ ${field === 'name' ? 'nom' : field === 'prenom' ? 'prénom' : field} est requis`;
    }
  });
  
  if (formData.role === 'expert' && !formData.tarif) {
    newErrors.tarif = 'Veuillez sélectionner un tarif';
  }
  
  if (formData.role === 'expert' && formData.tarif === 'payant' && !formData.prix) {
    newErrors.prix = 'Le prix est requis pour un service payant';
  }
  
  if (formData.role === 'expert' && selectedModes.length === 0) {
    newErrors.modes_accompagnement = 'Veuillez sélectionner au moins un mode d\'accompagnement';
  }
  
  if (formData.role === 'entreprise') {
    if (!formData.nom_entreprise) {
      newErrors.nom_entreprise = 'Le nom de l\'entreprise est requis';
    }
    if (!formData.secteur_activite) {
      newErrors.secteur_activite = 'Le secteur d\'activité est requis';
    }
    if (!formData.bio) {
      newErrors.bio = 'La présentation de l\'entreprise est requise';
    }
  }
  
  if (selectedServices.length === 0) {
    newErrors.services = 'Veuillez sélectionner au moins un service';
  }
  
  setErrors(newErrors);
  return Object.keys(newErrors).length === 0 && Object.keys(fieldErrors).length === 0;
};

const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitError('');
  setImageError('');
  
  const allFields = Object.keys(formData);
  const touchedAll = {};
  allFields.forEach(field => {
    touchedAll[field] = true;
  });
  setTouched(touchedAll);
  
  allFields.forEach(field => {
    validateField(field, formData[field]);
  });
  
  if (!validateForm()) {
    setSubmitError('Veuillez corriger les erreurs dans le formulaire');
    return;
  }

  // Créer FormData pour envoyer l'image
  const formDataToSend = new FormData();
  
  // Ajouter tous les champs au FormData SAUF les champs de tableaux
  Object.keys(formData).forEach(key => {
    if (formData[key] !== '' && formData[key] !== null) {
      // Ne pas envoyer les champs qui seront remplacés par les tableaux
      if (key !== 'services' && key !== 'modes_accompagnement' && key !== 'besoins') {
        formDataToSend.append(key, formData[key]);
      }
    }
  });
  
  // ESSAYEZ CETTE MÉTHODE DIFFÉRENTE pour les tableaux
  // Au lieu d'envoyer un JSON stringifié, envoyez chaque élément séparément
  if (selectedServices.length > 0) {
    selectedServices.forEach((service, index) => {
      formDataToSend.append(`services[${index}]`, service);
    });
  }
  
  if (selectedModes.length > 0) {
    selectedModes.forEach((mode, index) => {
      formDataToSend.append(`modes_accompagnement[${index}]`, mode);
    });
  }
  
  if (selectedBesoins.length > 0) {
    selectedBesoins.forEach((besoin, index) => {
      formDataToSend.append(`besoins[${index}]`, besoin);
    });
  }
  
  // Ajouter l'image si elle existe
  if (image) {
    formDataToSend.append('image', image);
  }

  // DEBUG: Afficher ce qui est envoyé
  console.log('Données envoyées au backend:');
  for (let pair of formDataToSend.entries()) {
    console.log(pair[0] + ':', pair[1]);
  }

  try {
    const response = await authService.register(formDataToSend);
    
    localStorage.setItem('temp_user', JSON.stringify({
      email: formData.email,
      name: formData.role === 'entreprise' ? formData.nom_entreprise : formData.name,
      prenom: formData.role === 'entreprise' ? '' : formData.prenom,
      role: formData.role,
      temp_token: response.token,
      verification_sent: response.verification_sent
    }));
    
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    navigate('/inscription/en-attente-verification', { 
      state: { 
        email: formData.email,
        name: formData.role === 'entreprise' ? formData.nom_entreprise : formData.name,
        prenom: formData.role === 'entreprise' ? '' : formData.prenom,
        verificationSent: true,
        message: 'Un email de vérification vous a été envoyé. Vérifiez votre boîte de réception.'
      } 
    });
    
  } catch (err) {
    console.error('Erreur complète:', err);
    console.error('Réponse erreur:', err.response);
    
    if (err.response?.data?.errors) {
      const serverErrors = err.response.data.errors;
      console.error('Erreurs serveur:', serverErrors);
      
      let errorMessage = 'Erreurs de validation :\n';
      
      Object.keys(serverErrors).forEach(key => {
        errorMessage += `• ${key}: ${Array.isArray(serverErrors[key]) ? serverErrors[key].join(', ') : serverErrors[key]}\n`;
      });
      
      setSubmitError(errorMessage);
    } else if (err.response?.data?.message) {
      console.error('Message erreur:', err.response.data.message);
      setSubmitError(err.response.data.message);
    } else if (err.message) {
      setSubmitError(err.message);
    } else {
      setSubmitError('Erreur lors de l\'inscription');
    }
  }
};

  const formatPhoneNumber = (value) => {
    const numbers = value.replace(/\D/g, '');
    if (numbers.length <= 2) return numbers;
    if (numbers.length <= 4) return `${numbers.slice(0, 2)} ${numbers.slice(2)}`;
    if (numbers.length <= 6) return `${numbers.slice(0, 2)} ${numbers.slice(2, 4)} ${numbers.slice(4)}`;
    if (numbers.length <= 8) return `${numbers.slice(0, 2)} ${numbers.slice(2, 4)} ${numbers.slice(4, 6)} ${numbers.slice(6)}`;
    return `${numbers.slice(0, 2)} ${numbers.slice(2, 4)} ${numbers.slice(4, 6)} ${numbers.slice(6, 8)} ${numbers.slice(8, 10)}`;
  };

  const handlePhoneChange = (e) => {
    const { value } = e.target;
    const formatted = formatPhoneNumber(value);
    setFormData(prev => ({ ...prev, telephone: formatted }));
    if (touched.telephone) {
      validateField('telephone', formatted);
    }
  };

  const formatSiret = (value) => {
    const numbers = value.replace(/\D/g, '');
    if (numbers.length <= 3) return numbers;
    if (numbers.length <= 6) return `${numbers.slice(0, 3)} ${numbers.slice(3)}`;
    if (numbers.length <= 9) return `${numbers.slice(0, 3)} ${numbers.slice(3, 6)} ${numbers.slice(6)}`;
    return `${numbers.slice(0, 3)} ${numbers.slice(3, 6)} ${numbers.slice(6, 9)} ${numbers.slice(9, 14)}`;
  };

  const handleSiretChange = (e) => {
    const { value } = e.target;
    const formatted = formatSiret(value);
    setFormData(prev => ({ ...prev, siret: formatted }));
    if (touched.siret) {
      validateField('siret', formatted);
    }
  };

  const isFieldInvalid = (fieldName) => {
    return (touched[fieldName] && fieldErrors[fieldName]) || errors[fieldName];
  };

  return (
    <div className="inscription-containercontain">
      <Link to="/" className="home-arrowinscription">
        <FaArrowLeft className="arrow-iconinscription" />
        Retour à l'accueil
      </Link>

      <div className="inscription-header">
        <h2>Rejoignez notre communauté</h2>
        <p>Commencez votre parcours dès aujourd'hui</p>
      </div>

      {submitError && <div className="error-message">{submitError}</div>}

      {step === 1 && (
        <div className="role-selection">
          <div className="role-header">
            <h3>Quel est votre profil ?</h3>
            <p>Sélectionnez le rôle qui correspond le mieux à votre situation</p>
          </div>
          <div className="role-cards">
            <div 
              className={`role-card ${formData.role === 'etudiant' ? 'selected' : ''}`}
              onClick={() => { setFormData({ ...formData, role: 'etudiant' }); setStep(2); }}
            >
              <div className="role-icon">
                <FaGraduationCap />
              </div>
              <div className="role-content">
                <h4>Étudiant</h4>
                <p>Je cherche du soutien et des opportunités</p>
              </div>
            </div>

            <div 
              className={`role-card ${formData.role === 'expert' ? 'selected' : ''}`}
              onClick={() => { setFormData({ ...formData, role: 'expert' }); setStep(2); }}
            >
              <div className="role-icon">
                <FaUserTie />
              </div>
              <div className="role-content">
                <h4>Expert</h4>
                <p>Je propose mes services professionnels</p>
              </div>
            </div>

            <div 
              className={`role-card ${formData.role === 'mentor' ? 'selected' : ''}`}
              onClick={() => { setFormData({ ...formData, role: 'mentor' }); setStep(2); }}
            >
              <div className="role-icon">
                <FaUserGraduate />
              </div>
              <div className="role-content">
                <h4>Mentor</h4>
                <p>Je partage mon expérience et conseils</p>
              </div>
            </div>

            <div 
              className={`role-card ${formData.role === 'entreprise' ? 'selected' : ''}`}
              onClick={() => { setFormData({ ...formData, role: 'entreprise' }); setStep(2); }}
            >
              <div className="role-icon">
                <FaBuilding />
              </div>
              <div className="role-content">
                <h4>Entreprise</h4>
                <p>Je représente une organisation</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {step === 2 && (
        <form onSubmit={handleSubmit} className="inscription-form">
          <div className="form-section">
            <h3 className="section-title">
              <span className="section-number">1</span>
              Informations personnelles
            </h3>
            
            {/* Champ d'upload d'image - AJOUTÉ ICI */}
            <div className="form-group">
              <label className="form-label">Photo de profil (optionnelle)</label>
              <div className="image-upload-container">
                <div className="image-preview-area">
                  {imagePreview ? (
                    <div className="image-preview-wrapper">
                      <img 
                        src={imagePreview} 
                        alt="Prévisualisation" 
                        className="image-preview"
                      />
                      <button 
                        type="button" 
                        className="remove-image-btn"
                        onClick={removeImage}
                        aria-label="Supprimer l'image"
                      >
                        <FaTimes />
                      </button>
                    </div>
                  ) : (
                    <div className="upload-placeholder">
                      <FaCamera className="upload-icon" />
                      <span>Aucune image sélectionnée</span>
                    </div>
                  )}
                </div>
                
                <div className="upload-controls">
                  <input
                    type="file"
                    id="image-upload"
                    accept="image/*"
                    onChange={handleImageUpload}
                    className="image-input"
                  />
                  <label htmlFor="image-upload" className="upload-btninscription">
                    <FaCamera />
                    Choisir une image
                  </label>
                  <div className="upload-info">
                    <small>Formats acceptés : JPG, PNG, GIF, WEBP</small>
                    <small>Taille max : 2MB</small>
                  </div>
                </div>
                {imageError && <span className="field-error">{imageError}</span>}
              </div>
            </div>
            
            <div className="form-columns">
              <div className="form-group">
                <label className="form-label required">Nom</label>
                <input 
                  type="text" 
                  name="name" 
                  value={formData.name} 
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={`form-input ${isFieldInvalid('name') ? 'invalid' : ''}`}
                  placeholder="Entrez votre nom"
                  maxLength="50"
                />
                {(touched.name && fieldErrors.name) || errors.name ? (
                  <span className="field-error">{fieldErrors.name || errors.name}</span>
                ) : null}
              </div>
              <div className="form-group">
                <label className="form-label required">Prénom</label>
                <input 
                  type="text" 
                  name="prenom" 
                  value={formData.prenom} 
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={`form-input ${isFieldInvalid('prenom') ? 'invalid' : ''}`}
                  placeholder="Entrez votre prénom"
                  maxLength="50"
                />
                {(touched.prenom && fieldErrors.prenom) || errors.prenom ? (
                  <span className="field-error">{fieldErrors.prenom || errors.prenom}</span>
                ) : null}
              </div>
            </div>
            
            <div className="form-group">
              <label className="form-label required">Email</label>
              <input 
                type="email" 
                name="email" 
                value={formData.email} 
                onChange={handleChange}
                onBlur={handleBlur}
                className={`form-input ${isFieldInvalid('email') ? 'invalid' : ''}`}
                placeholder="exemple@email.com"
              />
              {(touched.email && fieldErrors.email) || errors.email ? (
                <span className="field-error">{fieldErrors.email || errors.email}</span>
              ) : null}
            </div>
            
            <div className="form-group ville-autocomplete-container">
              <label className="form-label required">Ville</label>
              <div className="ville-autocomplete">
                <input
                  type="text"
                  name="ville"
                  value={formData.ville}
                  onChange={handleChange}
                  onBlur={(e) => {
                    handleBlur(e);
                    setTimeout(() => setShowVilleSuggestions(false), 200);
                  }}
                  onFocus={() => formData.ville.length >= 2 && setShowVilleSuggestions(true)}
                  placeholder="Entrez votre ville"
                  autoComplete="off"
                  className={`form-input ${isFieldInvalid('ville') ? 'invalid' : ''}`}
                />
                
                {showVilleSuggestions && villeSuggestions.length > 0 && (
                  <ul className="ville-suggestions">
                    {villeSuggestions.map((ville, index) => (
                      <li 
                        key={index} 
                        onClick={() => selectVille(ville)}
                        onMouseDown={(e) => e.preventDefault()}
                      >
                        {ville}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              {touched.ville && fieldErrors.ville ? (
                <span className="field-error">{fieldErrors.ville}</span>
              ) : null}
            </div>
            
            <div className="form-columns">
              <div className="form-group">
                <label className="form-label required">Mot de passe</label>
                <div className="password-input-container">
                  <input 
                    type={showPassword ? "text" : "password"}
                    name="password" 
                    value={formData.password} 
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={`form-input ${isFieldInvalid('password') ? 'invalid' : ''}`}
                    placeholder="Créez un mot de passe sécurisé (min. 8 caractères)"
                  />
                  <button 
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                {(touched.password && fieldErrors.password) || errors.password ? (
                  <span className="field-error">{fieldErrors.password || errors.password}</span>
                ) : null}
              </div>
              <div className="form-group">
                <label className="form-label required">Confirmation mot de passe</label>
                <div className="password-input-container">
                  <input 
                    type={showConfirmPassword ? "text" : "password"}
                    name="password_confirmation" 
                    value={formData.password_confirmation} 
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={`form-input ${isFieldInvalid('password_confirmation') ? 'invalid' : ''}`}
                    placeholder="Confirmez votre mot de passe"
                  />
                  <button 
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    aria-label={showConfirmPassword ? "Masquer la confirmation" : "Afficher la confirmation"}
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                {(touched.password_confirmation && fieldErrors.password_confirmation) || errors.password_confirmation ? (
                  <span className="field-error">{fieldErrors.password_confirmation || errors.password_confirmation}</span>
                ) : null}
              </div>
            </div>
          </div>

          {/* Champs spécifiques */}
          {formData.role === 'etudiant' && (
            <div className="form-section">
              <h3 className="section-title">
                <span className="section-number">2</span>
                Informations étudiant
              </h3>
              <div className="form-columns">
                <div className="form-group">
                  <label className="form-label">Niveau d'étude</label>
                  <select name="niveau_etude" value={formData.niveau_etude} onChange={handleChange} className="form-select">
                    <option value="">Sélectionnez un niveau</option>
                    {niveauxEtude.map(niveau => (
                      <option key={niveau} value={niveau}>{niveau}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group pays-autocomplete-container">
                  <label className="form-label required">Pays d'origine</label>
                  <div className="pays-autocomplete">
                    <input
                      type="text"
                      name="pays_origine"
                      value={formData.pays_origine}
                      onChange={handleChange}
                      onBlur={(e) => {
                        handleBlur(e);
                        setTimeout(() => setShowPaysSuggestions(false), 200);
                      }}
                      onFocus={() => formData.pays_origine.length >= 2 && setShowPaysSuggestions(true)}
                      placeholder="Entrez votre pays d'origine"
                      autoComplete="off"
                      className="form-input"
                    />
                    
                    {showPaysSuggestions && paysSuggestions.length > 0 && (
                      <ul className="pays-suggestions">
                        {paysSuggestions.map((pays, index) => (
                          <li 
                            key={index} 
                            onClick={() => selectPays(pays)}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            {pays}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {formData.role === 'expert' && (
            <div className="form-section">
              <h3 className="section-title">
                <span className="section-number">2</span>
                Informations expert
              </h3>
              <div className="form-columns">
                <div className="form-group">
                  <label className="form-label required">Tarif</label>
                  <select 
                    name="tarif" 
                    value={formData.tarif} 
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={`form-select ${isFieldInvalid('tarif') ? 'invalid' : ''}`}
                  >
                    <option value="">Sélectionnez une option</option>
                    <option value="gratuit">Gratuit</option>
                    <option value="payant">Payant</option>
                    <option value="les deux">Les deux</option>
                  </select>
                  {(touched.tarif && fieldErrors.tarif) || errors.tarif ? (
                    <span className="field-error">{fieldErrors.tarif || errors.tarif}</span>
                  ) : null}
                </div>
                <div className="form-group">
                  <label className={`form-label ${formData.tarif === 'payant' || formData.tarif === 'les deux' ? 'required' : ''}`}>
                    Prix
                  </label>
                  <input 
                    type="text" 
                    name="prix" 
                    value={formData.prix} 
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={formData.tarif === 'gratuit'}
                    placeholder={formData.tarif === 'gratuit' ? 'Non applicable' : 'Prix en € (ex: 50 ou 49.99)'}
                    className={`form-input ${isFieldInvalid('prix') ? 'invalid' : ''}`}
                  />
                  {(touched.prix && fieldErrors.prix) || errors.prix ? (
                    <span className="field-error">{fieldErrors.prix || errors.prix}</span>
                  ) : null}
                </div>
              </div>
              
              <div className="form-group">
                <label className="form-label required">Modes d'accompagnement</label>
                <div className="modes-selection">
                  <div className="mode-options">
                    <button
                      type="button"
                      className={`mode-btn ${selectedModes.includes('En ligne') ? 'selected' : ''}`}
                      onClick={() => handleModeSelection('En ligne')}
                    >
                      En ligne
                    </button>
                    <button
                      type="button"
                      className={`mode-btn ${selectedModes.includes('En présentiel') ? 'selected' : ''}`}
                      onClick={() => handleModeSelection('En présentiel')}
                    >
                      En présentiel
                    </button>
                    <button
                      type="button"
                      className={`mode-btn ${selectedModes.includes('Les deux') ? 'selected' : ''}`}
                      onClick={() => handleModeSelection('Les deux')}
                    >
                      Les deux
                    </button>
                  </div>
                  <div className="modes-preview">
                    {selectedModes.length > 0 ? (
                      <span>Sélectionné(s) : {selectedModes.join(', ')}</span>
                    ) : (
                      <span className="placeholder">Sélectionnez au moins un mode</span>
                    )}
                  </div>
                </div>
                {(touched.modes_accompagnement && fieldErrors.modes_accompagnement) || errors.modes_accompagnement ? (
                  <span className="field-error">{fieldErrors.modes_accompagnement || errors.modes_accompagnement}</span>
                ) : null}
              </div>
              
              <div className="form-group region-autocomplete-container">
                <label className="form-label">Région couverte</label>
                <div className="region-autocomplete">
                  <input
                    type="text"
                    name="region_couverte"
                    value={formData.region_couverte}
                    onChange={handleChange}
                    onBlur={(e) => {
                      handleBlur(e);
                      setTimeout(() => setShowRegionSuggestions(false), 200);
                    }}
                    onFocus={() => formData.region_couverte.length >= 2 && setShowRegionSuggestions(true)}
                    placeholder="Région(s) où vous intervenez"
                    autoComplete="off"
                    className="form-input"
                  />
                  
                  {showRegionSuggestions && regionSuggestions.length > 0 && (
                    <ul className="region-suggestions">
                      {regionSuggestions.map((region, index) => (
                        <li 
                          key={index} 
                          onClick={() => selectRegion(region)}
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          {region}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          )}

{formData.role === 'entreprise' && (
  <div className="form-section">
    <h3 className="section-title">
      <span className="section-number">2</span>
      Informations entreprise
    </h3>
    <div className="form-columns">
      <div className="form-group">
        <label className="form-label required">Nom entreprise</label>
        <input 
          type="text" 
          name="nom_entreprise" 
          value={formData.nom_entreprise} 
          onChange={handleChange}
          onBlur={handleBlur}
          className={`form-input ${isFieldInvalid('nom_entreprise') ? 'invalid' : ''}`}
          placeholder="Nom de votre entreprise"
        />
        {touched.nom_entreprise && fieldErrors.nom_entreprise ? (
          <span className="field-error">{fieldErrors.nom_entreprise}</span>
        ) : null}
      </div>
      <div className="form-group">
        <label className="form-label required">Secteur d'activité</label>
        <input 
          type="text" 
          name="secteur_activite" 
          value={formData.secteur_activite} 
          onChange={handleChange}
          onBlur={handleBlur}
          className={`form-input ${isFieldInvalid('secteur_activite') ? 'invalid' : ''}`}
          placeholder="Secteur d'activité (ex: Informatique, Construction...)"
        />
        {touched.secteur_activite && fieldErrors.secteur_activite ? (
          <span className="field-error">{fieldErrors.secteur_activite}</span>
        ) : null}
      </div>
    </div>
    <div className="form-columns">
      <div className="form-group">
        <label className="form-label">SIRET</label>
        <input 
          type="text" 
          name="siret" 
          value={formData.siret} 
          onChange={handleSiretChange}
          onBlur={handleBlur}
          className={`form-input ${isFieldInvalid('siret') ? 'invalid' : ''}`}
          placeholder="123 456 789 01234"
          maxLength="17"
        />
        {touched.siret && fieldErrors.siret ? (
          <span className="field-error">{fieldErrors.siret}</span>
        ) : null}
      </div>
      <div className="form-group">
        <label className="form-label">Site internet</label>
        <input 
          type="text" 
          name="site_internet" 
          value={formData.site_internet} 
          onChange={handleChange}
          onBlur={handleBlur}
          className={`form-input ${isFieldInvalid('site_internet') ? 'invalid' : ''}`}
          placeholder="www.votre-entreprise.com"
        />
        {touched.site_internet && fieldErrors.site_internet ? (
          <span className="field-error">{fieldErrors.site_internet}</span>
        ) : null}
      </div>
    </div>
    
    <div className="form-group">
      <label className="form-label required">Présentation de l'entreprise</label>
      <textarea 
        name="bio" 
        value={formData.bio} 
        onChange={handleChange}
        onBlur={handleBlur}
        className={`form-textarea ${isFieldInvalid('bio') ? 'invalid' : ''}`}
        placeholder="Présentez votre entreprise en quelques mots..."
        maxLength="500"
      />
      <div style={{ textAlign: 'right', fontSize: '0.875rem', color: '#64748b', marginTop: '0.5rem' }}>
        {formData.bio.length}/500 caractères
      </div>
      {touched.bio && fieldErrors.bio ? (
        <span className="field-error">{fieldErrors.bio}</span>
      ) : null}
    </div>
  </div>
)}

          {formData.role === 'mentor' && (
            <div className="form-section">
              <h3 className="section-title">
                <span className="section-number">2</span>
                Informations mentor
              </h3>
              <div className="form-columns">
                <div className="form-group specialite-autocomplete-container">
                  <label className="form-label">Spécialité d'étude</label>
                  <div className="specialite-autocomplete">
                    <input
                      type="text"
                      name="specialite_etudes"
                      value={formData.specialite_etudes}
                      onChange={handleChange}
                      onBlur={(e) => {
                        handleBlur(e);
                        setTimeout(() => setShowSpecialiteSuggestions(false), 200);
                      }}
                      onFocus={() => formData.specialite_etudes.length >= 2 && setShowSpecialiteSuggestions(true)}
                      placeholder="Entrez votre spécialité d'étude"
                      autoComplete="off"
                      className="form-input"
                    />
                    
                    {showSpecialiteSuggestions && specialiteSuggestions.length > 0 && (
                      <ul className="specialite-suggestions">
                        {specialiteSuggestions.map((specialite, index) => (
                          <li 
                            key={index} 
                            onClick={() => selectSpecialite(specialite)}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            {specialite}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
                <div className="form-group secteur-pro-autocomplete-container">
                  <label className="form-label">Secteur d'activité pro</label>
                  <div className="secteur-pro-autocomplete">
                    <input
                      type="text"
                      name="secteur_pro"
                      value={formData.secteur_pro}
                      onChange={handleChange}
                      onBlur={(e) => {
                        handleBlur(e);
                        setTimeout(() => setShowSecteurProSuggestions(false), 200);
                      }}
                      onFocus={() => formData.secteur_pro.length >= 2 && setShowSecteurProSuggestions(true)}
                      placeholder="Entrez votre secteur professionnel"
                      autoComplete="off"
                      className="form-input"
                    />
                    
                    {showSecteurProSuggestions && secteurProSuggestions.length > 0 && (
                      <ul className="secteur-pro-suggestions">
                        {secteurProSuggestions.map((secteur, index) => (
                          <li 
                            key={index} 
                            onClick={() => selectSecteurPro(secteur)}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            {secteur}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-columns">
                <div className="form-group">
                  <label className="form-label">Année arrivée en France</label>
                  <select 
                    name="annee_arrivee_fr" 
                    value={formData.annee_arrivee_fr} 
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">Sélectionnez une année</option>
                    {years.map(year => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group"></div>
              </div>
            </div>
          )}

          {/* Champs additionnels communs */}
          <div className="form-section">
            <h3 className="section-title">
              <span className="section-number">3</span>
              Informations complémentaires
            </h3>
            <div className="form-columns">
              <div className="form-group">
                <label className="form-label">Téléphone</label>
                <input 
                  type="text" 
                  name="telephone" 
                  value={formData.telephone} 
                  onChange={handlePhoneChange}
                  onBlur={handleBlur}
                  className={`form-input ${isFieldInvalid('telephone') ? 'invalid' : ''}`}
                  placeholder="06 12 34 56 78"
                  maxLength="14"
                />
                {touched.telephone && fieldErrors.telephone ? (
                  <span className="field-error">{fieldErrors.telephone}</span>
                ) : null}
              </div>
              <div className="form-group">
                <label className="form-label">LinkedIn</label>
                <input 
                  type="text" 
                  name="linkedin" 
                  value={formData.linkedin} 
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={`form-input ${isFieldInvalid('linkedin') ? 'invalid' : ''}`}
                  placeholder="https://linkedin.com/in/votre-profil"
                />
                {touched.linkedin && fieldErrors.linkedin ? (
                  <span className="field-error">{fieldErrors.linkedin}</span>
                ) : null}
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Présentation</label>
              <textarea 
                name="bio" 
                value={formData.bio} 
                onChange={handleChange}
                onBlur={handleBlur}
                className={`form-textarea ${isFieldInvalid('bio') ? 'invalid' : ''}`}
                placeholder="Présentez-vous en quelques mots..."
                maxLength="500"
              />
              <div style={{ textAlign: 'right', fontSize: '0.875rem', color: '#64748b', marginTop: '0.5rem' }}>
                {formData.bio.length}/500 caractères
              </div>
              {touched.bio && fieldErrors.bio ? (
                <span className="field-error">{fieldErrors.bio}</span>
              ) : null}
            </div>
            
            {(formData.role === 'etudiant' || formData.role === 'expert' || formData.role === 'mentor') && (
              <div className="form-group">
                <label className="form-label required">Mes besoins / Services proposés</label>
                <select 
                  multiple
                  value={selectedServices}
                  onChange={handleServiceSelection}
                  className={`multi-select ${(touched.services && fieldErrors.services) || errors.services ? 'invalid' : ''}`}
                  size={5}
                  onBlur={() => setTouched(prev => ({ ...prev, services: true }))}
                >
                  {customServices.map(category => (
                    <optgroup key={category.nom} label={category.nom} className="select-optgroup">
                      {category.sous_services.map(service => (
                        <option key={service.id} value={service.nom} className="select-option">
                          {service.nom}
                        </option>
                      ))}
                    </optgroup>
                  ))}
                </select>
                <small className="select-help">Maintenez Ctrl (ou Cmd) pour sélectionner plusieurs services</small>
                {(touched.services && fieldErrors.services) || errors.services ? (
                  <span className="field-error">{fieldErrors.services || errors.services}</span>
                ) : null}
              </div>
            )}
            
{formData.role === 'entreprise' && (
  <div className="form-group">
    <label className="form-label required">Services proposés</label>
    <select 
      multiple
      value={selectedServices}
      onChange={handleServiceSelection}
      className={`multi-select ${(touched.services && fieldErrors.services) || errors.services ? 'invalid' : ''}`}
      size={5}
      onBlur={() => setTouched(prev => ({ ...prev, services: true }))}
    >
      {customServices.map(category => (
        <optgroup key={category.nom} label={category.nom} className="select-optgroup">
          {category.sous_services.map(service => (
            <option key={service.id} value={service.nom} className="select-option">
              {service.nom}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
    <small className="select-help">Maintenez Ctrl (ou Cmd) pour sélectionner plusieurs services</small>
    {(touched.services && fieldErrors.services) || errors.services ? (
      <span className="field-error">{fieldErrors.services || errors.services}</span>
    ) : null}
  </div>
)}
          </div>

          <div className="form-footer">
            <button 
              type="submit" 
              className="submit-btn"
              disabled={Object.keys(fieldErrors).length > 0 || Object.keys(errors).length > 0}
            >
              Créer mon compte
            </button>
            <p className="switch-auth">
              Déjà un compte ? <span onClick={() => navigate('/connexion')}>Se connecter</span>
            </p>
          </div>
        </form>
      )}
    </div>
  );
};

export default Inscription;